import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { WithdrawalInstruction } from '../../../../../models/submissions/withdrawal-instruction';

export interface WithdrawalInstructionDisplayItem {
  instruction: WithdrawalInstruction;
  changed: boolean;
}

@Component({
  selector: 'app-vb-payment-change-submission-withdrawal-details-card',
  templateUrl: './vb-payment-change-submission-withdrawal-details-card.component.html',
  styleUrls: ['./vb-payment-change-submission-withdrawal-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VbPaymentChangeSubmissionWithdrawalDetailsCardComponent implements OnChanges {
  @Input({ required: true }) currentWithdrawalInstructions!: WithdrawalInstruction[];
  @Input({ required: true }) newWithdrawalInstructions!: WithdrawalInstruction[];

  public hasChanges = false;
  public currentDisplayItems: WithdrawalInstructionDisplayItem[] = [];
  public newDisplayItems: WithdrawalInstructionDisplayItem[] = [];
  public unchangedDisplayItems: WithdrawalInstructionDisplayItem[] = [];

  public ngOnChanges(): void {
    const current = this.filterAndSort(this.currentWithdrawalInstructions ?? []);
    const updated = this.filterAndSort(this.newWithdrawalInstructions ?? []);

    const changedFundIds = this.getChangedFundIds(current, updated);
    this.hasChanges = changedFundIds.size > 0;

    if (this.hasChanges) {
      this.currentDisplayItems = current.map(instruction => ({
        instruction,
        changed: changedFundIds.has(instruction.fundId)
      }));
      this.newDisplayItems = updated.map(instruction => ({
        instruction,
        changed: changedFundIds.has(instruction.fundId)
      }));
    } else {
      this.unchangedDisplayItems = current.map(instruction => ({
        instruction,
        changed: false
      }));
    }
  }

  private filterAndSort(instructions: WithdrawalInstruction[]): WithdrawalInstruction[] {
    return instructions.filter(i => i.percentage > 0).sort((a, b) => a.fundId - b.fundId);
  }

  private getChangedFundIds(current: WithdrawalInstruction[], updated: WithdrawalInstruction[]): Set<number> {
    const changedIds = new Set<number>();
    const currentMap = new Map(current.map(i => [i.fundId, i.percentage]));
    const updatedMap = new Map(updated.map(i => [i.fundId, i.percentage]));

    const allFundIds = new Set([...currentMap.keys(), ...updatedMap.keys()]);

    for (const fundId of allFundIds) {
      const currentPct = currentMap.get(fundId);
      const updatedPct = updatedMap.get(fundId);
      if (currentPct !== updatedPct) {
        changedIds.add(fundId);
      }
    }

    return changedIds;
  }
}
